module.exports = __webpack_public_path__ + "static/media/jxll_bz.14b4bdde.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/jxll_bz.png
// module id = 1917
// module chunks = 6